import React from 'react'
import { SanityFullWidthTeaser } from '../../../../../types/generated/graphql-types'
import { useTranslations } from '../../../../hooks/useTranslations'
import { mapSanityFullWidthTeaserToFullWidthTeaserProps } from '../../../../mapping/FullWidthTeaserMapper'
import { BlockWithId } from '../../../../utilities/blockId'
import { FullWidthTeaser } from '../../../blocks/FullWidthTeaser'

export type FullWidthTeaserSerializerProps = SanityFullWidthTeaser & BlockWithId

export const FullWidthTeaserSerializer = ({
  id,
  ...props
}: FullWidthTeaserSerializerProps) => {
  const translations = useTranslations()

  return (
    <FullWidthTeaser
      {...mapSanityFullWidthTeaserToFullWidthTeaserProps(props, translations)}
      id={id}
    />
  )
}
